import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../Menu";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddSubGroup = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    groupid: parseInt(id) || 0,
    name: "",
    remark: "",
    active: true,
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  const token = getCookie("token");
  const userid = getCookie("userid");
  const baseApiUrl = "https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/SubUser";

  // Update groupid when id parameter changes
  useEffect(() => {
    if (id) {
      setFormData((prev) => ({
        ...prev,
        groupid: parseInt(id),
      }));
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      setMessage("SubGroup name is required");
      setMessageType("error");
      return;
    }

    if (!formData.remark.trim()) {
      setMessage("Remark is required");
      setMessageType("error");
      return;
    }

    setLoading(true);

    try {
      const SubGroupInsert = getUrlByOperation("SubGroupInsert") ||
        `${baseApiUrl}/Insert`;

      const response = await axios.post(
        SubGroupInsert,
        {
          groupid: formData.groupid,
          name: formData.name,
          remark: formData.remark,
          active: formData.active,
        },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
            accept: "text/plain",
          },
        }
      );

      // Check if the API response indicates success or failure
      if (response.data && response.data.isresponse && response.data.responsestatus !== "FAIL") {
        setMessage("SubGroup added successfully!");
        setMessageType("success");
        // Redirect after 1.5 seconds
        setTimeout(() => {
          navigate(`/subgroup/${formData.groupid}`);
        }, 1500);
      } else {
        // Display the error message from API
        setMessage(response.data?.errormsg || "Failed to add SubGroup");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error adding SubGroup:", error);
      setMessage("Failed to add SubGroup");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/subgroup/${formData.groupid}`);
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add SubGroup</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-subgroup" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>SubGroup Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                placeholder="Enter subgroup name"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                name="remark"
                                value={formData.remark}
                                onChange={handleInputChange}
                                placeholder="Enter remark/description"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="active"
                                  name="active"
                                  checked={formData.active}
                                  onChange={handleInputChange}
                                />
                                <label className="custom-control-label" htmlFor="active">
                                  Active
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-subgroup-btn"
                            className="btn btn-info"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-1"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Adding...
                              </>
                            ) : (
                              "Add"
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-default ml-2"
                            onClick={handleCancel}
                            disabled={loading}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "SubGroup added successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message && message !== "SubGroup added successfully!" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AddSubGroup;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

